import { getStage } from "./journey";

/**
 * "Comienza tu viaje" assessment.
 * Recommends the best STARTING stage — never a pass/fail score.
 * Each option points to the transformation stage it signals.
 */
export const ASSESSMENT_QUESTIONS = [
  {
    id: "q1",
    prompt: "¿Qué describe mejor tu momento actual?",
    options: [
      { label: "Quiero entender por qué soy como soy.", stage: 1 },
      { label: "Repito patrones y no sé por qué.", stage: 2 },
      { label: "Cargo heridas o emociones del pasado.", stage: 3 },
      { label: "Me cuesta manejar el estrés y las emociones.", stage: 4 },
      { label: "Quiero aplicar lo que ya sé a mi vida.", stage: 5 },
    ],
  },
  {
    id: "q2",
    prompt: "¿Con qué frase te identificas más?",
    options: [
      { label: "“No sé quién soy realmente.”", stage: 1 },
      { label: "“Sé qué hago mal, pero lo repito.”", stage: 2 },
      { label: "“Hay dolor que aún no he sanado.”", stage: 3 },
      { label: "“Mi cuerpo vive en alerta.”", stage: 4 },
      { label: "“Quiero relaciones y hábitos más conscientes.”", stage: 5 },
    ],
  },
  {
    id: "q3",
    prompt: "¿Qué buscas ahora mismo?",
    options: [
      { label: "Autoconocimiento y origen.", stage: 1 },
      { label: "Comprender mis patrones.", stage: 2 },
      { label: "Sanar mi historia.", stage: 3 },
      { label: "Calma y regulación.", stage: 4 },
      { label: "Transformación práctica.", stage: 5 },
    ],
  },
  {
    id: "q4",
    prompt: "¿Cómo te relacionas hoy con tus emociones?",
    options: [
      { label: "Apenas las observo o las nombro.", stage: 1 },
      { label: "Las reconozco, pero se repiten.", stage: 2 },
      { label: "Me remueven heridas antiguas.", stage: 3 },
      { label: "Las siento, pero me desbordan.", stage: 4 },
      { label: "Las gestiono y quiero profundizar.", stage: 5 },
    ],
  },
];

/**
 * @param {number[]} answers - array of chosen stage numbers.
 * @returns {{ stage: object, reason: string }}
 */
export const scoreAssessment = (answers = []) => {
  const tally = {};
  answers.forEach((s) => {
    tally[s] = (tally[s] || 0) + 1;
  });
  // Highest signal wins; on a tie, start earlier in the journey.
  let best = 1;
  let bestCount = -1;
  Object.keys(tally)
    .map(Number)
    .sort((a, b) => a - b)
    .forEach((s) => {
      if (tally[s] > bestCount) {
        bestCount = tally[s];
        best = s;
      }
    });
  return { stage: getStage(best), reason: getStage(best)?.why };
};

// Mandated framing — never "you passed".
export const ASSESSMENT_RESULT_COPY =
  "Según tus respuestas, te recomendamos comenzar tu viaje de transformación aquí.";
